<template>
  <v-container>
    <v-row justify="center">
      <ViewHeader :title="viewTitle" />
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <v-card class="pa-4">
              <template v-if="!websites.length > 0">
                <div class="competition__card">
                  <NoDataInfo
                    v-if="!websites.length > 0"
                    :title="$t('message.competition.visibility.nodata.title')"
                    :description="
                      $t('message.competition.visibility.nodata.content')
                    "
                    :buttonName="$t('message.common.newWebsite')"
                    buttonRouteName="profile-websites"
                  />
                </div>
              </template>
              <template v-else>
                <v-row>
                  <v-col cols="12" lg="6" xl="4" class="pa-3">
                    <v-card class="pa-4" outlined>
                      <v-row>
                        <v-col cols="3" class="px-2">
                          <v-select
                            :items="protocols"
                            v-model="defaultProtocol"
                          ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-text-field
                            name="urlField"
                            :label="
                              $t(
                                'message.competition.websites.inputPlaceholder'
                              )
                            "
                            data-vv-name="URL"
                            v-validate.disable="{
                              url: {
                                protocols: ['http', 'https'],
                                require_protocol: false
                              }
                            }"
                            :error-messages="errors.collect('URL')"
                            v-model="websiteUrl"
                            hint="www.twoja-strona.pl"
                            @keyup.enter="addWebsiteToList"
                            :loading="loadingInput"
                          />
                        </v-col>
                        <v-col cols="12" sm="3" align-self="center">
                          <v-btn
                            color="primary"
                            block
                            @click="addWebsiteToList"
                            :loading="loadingInput"
                          >
                            {{ $t("message.common.add") }}
                          </v-btn>
                        </v-col>
                        <v-col cols="12" class="info-hint px-2 pt-0">
                          <p class="grey--text">
                            {{ $t("message.wizard.websitesInfoHint") }}
                          </p>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <template v-if="competitionWebsites.length > 0">
                            <v-list
                              class="wizard__list overflow-y-auto"
                              height="406px"
                            >
                              <v-list-item
                                v-for="item in competitionWebsites"
                                :key="item.id"
                                ripple
                                @click="setSelectedCompetitionWebsite(item)"
                                :class="setActiveClass(item.id)"
                              >
                                <v-list-item-content>
                                  <v-list-item-title>
                                    <span class="item-text">{{
                                      item.url
                                    }}</span>
                                  </v-list-item-title>
                                </v-list-item-content>
                                <v-menu left>
                                  <template #activator="{ on }">
                                    <v-btn icon v-on="on">
                                      <v-icon color="primary">
                                        more_horiz
                                      </v-icon>
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <v-list-item>
                                      <v-btn
                                        color="error"
                                        text
                                        @click="deleteFromList(item)"
                                      >
                                        {{ $t("message.common.delete") }}
                                      </v-btn>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-list-item>
                            </v-list>
                          </template>
                          <template v-else>
                            <div
                              class="d-flex align-center justify-center "
                              style="min-height: 400px;"
                            >
                              <span class="no-data-info body-1">
                                Wprowadź adresy stron www twojej konkurencji
                              </span>
                            </div>
                          </template>
                          <SectionLoader :status="loadingWebsitesList" />
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="6"
                    xl="8"
                    order="2"
                    order-sm="1"
                    class="pa-3 overflow-hidden"
                  >
                    <div style="position: relative;">
                      <div class="laptop-screenshot">
                        <div class="laptop-screenshot__placeholder">
                          <transition name="fade" mode="out-in">
                            <v-img
                              :key="screenshot.laptop.screenshotSrc"
                              v-if="screenshot.laptop.screenshotSrc"
                              :src="screenshot.laptop.screenshotSrc"
                              :lazy-src="screenshot.laptop.screenshotSrc"
                              :alt="screenshot.laptop.alt"
                              class="laptop-screenshot__image"
                              contain
                              @error="screenshot.laptop.screenshotSrc = null"
                            />
                          </transition>
                          <div
                            v-if="
                              competitionWebsites.length > 0 &&
                                !screenshot.laptop.screenshotSrc
                            "
                            class="d-flex flex-column align-center"
                          >
                            <v-icon x-large class="ma-2" color="primary">
                              mdi-database-search
                            </v-icon>
                            <span class="placeholder__text body-1">
                              Zbieramy dane
                            </span>
                          </div>
                          <span
                            v-if="
                              !competitionWebsites.length > 0 &&
                                !screenshot.laptop.screenshotSrc
                            "
                            class="body-1 placeholder__text"
                          >
                            Wybierz stronę www
                          </span>
                        </div>
                        <SectionLoader :status="loadingScreenshot" />
                      </div>
                      <div class="mobile-screenshot">
                        <div class="mobile-screenshot__placeholder">
                          <transition name="fade" mode="out-in">
                            <v-img
                              :key="screenshot.mobile.screenshotSrc"
                              v-if="screenshot.mobile.screenshotSrc"
                              :src="screenshot.mobile.screenshotSrc"
                              :lazy-src="screenshot.mobile.screenshotSrc"
                              :alt="screenshot.mobile.alt"
                              class="mobile-screenshot__image"
                              contain
                              @error="screenshot.mobile.screenshotSrc = null"
                            />
                          </transition>
                          <div
                            v-if="
                              competitionWebsites.length > 0 &&
                                !screenshot.mobile.screenshotSrc
                            "
                            class="d-flex flex-column align-center"
                          >
                            <v-icon x-large class="ma-2" color="primary">
                              mdi-database-search
                            </v-icon>
                            <span class="placeholder__text body-1">
                              Zbieramy dane
                            </span>
                          </div>
                          <span
                            v-if="
                              !competitionWebsites.length > 0 &&
                                !screenshot.mobile.screenshotSrc
                            "
                            class="body-1 placeholder__text"
                          >
                            Wybierz stronę www
                          </span>
                        </div>
                        <SectionLoader :status="loadingScreenshot" />
                      </div>
                    </div>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="12">
                    <div class="d-flex">
                      <h4 class="my-2">{{ $t("message.common.suggested") }}</h4>
                      <v-tooltip bottom :max-width="tooltipMaxWidth">
                        <template v-slot:activator="{ on }">
                          <v-icon small color="primary" v-on="on" class="ml-1">
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span>{{
                          $t("message.competition.websites.suggestedTooltip")
                        }}</span>
                      </v-tooltip>
                    </div>
                  </v-col>
                </v-row>
                <v-footer min-height="80px" ref="footer">
                  <template v-if="!suggestedCompetitionWebsites.length > 0">
                    <div
                      class="d-flex justify-center align-center no-suggested"
                    >
                      <span class="body-1">
                        Brak sugerowanych stron www konkurencji
                      </span>
                    </div>
                  </template>
                  <template v-else>
                    <v-chip
                      large
                      v-for="competition in suggestedCompetitionWebsites"
                      outlined
                      :key="competition.id"
                      class="ma-1 chip"
                      style="background: white !important;"
                      @click="addSuggestedToList(competition)"
                    >
                      <div class="d-flex flex-column ma-4">
                        <span>{{ competition.url }}</span>
                      </div>
                    </v-chip>
                  </template>
                  <SectionLoader :status="loadingSuggested" />
                </v-footer>
              </template>
              <SectionLoader :status="loading" :opacity="1" />
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ViewHeader from "@/components/ui/ViewHeader.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import NoDataInfo from "@/components/Visibility/NoDataInfo.vue";
import competitionService from "@/services/competition";
import websitesService from "@/services/websites";
import serviceHandler from "@/helpers/handlers/service";
import ErrorHandler from "@/helpers/handlers/error";

import { trimUrlProtocol } from "@/helpers/helpers";

import { mapState } from "vuex";

import cuid from "cuid";

export default {
  name: "CompetitionWebsites",
  components: {
    ViewHeader,
    SectionLoader,
    NoDataInfo
  },

  data() {
    return {
      loading: false,
      loadingInput: false,
      loadingSuggested: false,
      loadingWebsitesList: false,
      loadingScreenshot: false,
      tooltipMaxWidth: 500,
      urlField: null,
      websiteUrl: "",
      websites: [],
      screenshot: {
        laptop: {
          alt: "Podgląd strony na laptopie",
          screenshotSrc: ""
        },
        mobile: {
          alt: "Podgląd strony na smartfonie",
          screenshotSrc: ""
        }
      },
      viewTitle: this.$t("message.competition.header"),
      competitionWebsites: [],
      selectedWebsite: null,
      suggestedCompetitionWebsites: [],
      protocols: ["https://", "http://"],
      defaultProtocol: "https://"
    };
  },

  computed: {
    ...mapState({
      companyId: state => state.company.id
    })
  },

  async created() {
    this.loading = true;
    await this.fetchWebsites();
    if (this.websites.length > 0) {
      await this.fetchCompetitionWebsites();
      if (this.competitionWebsites.length > 0) {
        await this.selectFirstWebsite();
      }
      await this.fetchSuggestedWebsites();
    }
    this.loading = false;
  },

  updated() {
    this.selectedWebsite || this.selectFirstWebsite();
  },

  watch: {
    websiteUrl(value) {
      const newVal = value ? trimUrlProtocol(value) : value;

      this.websiteUrl = newVal;
    }
  },

  methods: {
    async fetchWebsites() {
      this.websites = await serviceHandler(websitesService.getWebsitesData());
    },

    async fetchCompetitionWebsites() {
      const data = await serviceHandler(
        competitionService.getCompetitionWebsites(this.companyId)
      );

      this.competitionWebsites = data;
    },

    async addWebsiteToList() {
      if (this.websiteUrl) {
        this.urlField = `${this.defaultProtocol}${this.websiteUrl}`;

        const isOnList = this.competitionWebsites.find(
          website => website.url === this.urlField
        );

        !isOnList ? this.add(this.urlField) : null;
      }
    },

    async add(url) {
      this.loadingInput = true;
      await serviceHandler(
        competitionService.postCompetitionWebsite(this.companyId, {
          url: this.urlField,
          name: this.urlField
        })
      );

      this.fetchCompetitionWebsites();

      this.websiteUrl = null;
      this.loadingInput = false;
    },

    async deleteFromList(website) {
      const removeFromArr = (arr, websiteId) => {
        const index = arr.findIndex(item => item.id === website.id);
        arr.splice(index, 1);

        return arr;
      };

      await serviceHandler(
        competitionService.deleteCompetitionWebsite(this.companyId, website.id)
      );

      await this.fetchSuggestedWebsites();

      removeFromArr(this.competitionWebsites, website.id);
      this.selectFirstWebsite();
    },

    async fetchSuggestedWebsites() {
      const data = await serviceHandler(
        competitionService.getSuggestedWebsites(this.companyId)
      );

      this.suggestedCompetitionWebsites = data.map(item => {
        return {
          ...item,
          id: cuid()
        };
      });
    },

    async addSuggestedToList(val) {
      this.loadingSuggested = true;
      this.loadingWebsitesList = true;

      await serviceHandler(
        competitionService.postCompetitionWebsite(this.companyId, {
          url: val.url,
          name: val.url
        })
      );

      await this.fetchCompetitionWebsites();
      await this.fetchSuggestedWebsites();
      this.loadingSuggested = false;
      this.loadingWebsitesList = false;
    },

    setSelectedCompetitionWebsite(item) {
      this.loadingScreenshot = true;
      this.selectedWebsite = item;
      this.screenshot.laptop.screenshotSrc = item.screenshot_desktop_url;
      this.screenshot.mobile.screenshotSrc = item.screenshot_mobile_url;
      this.loadingScreenshot = false;
    },

    setActiveClass(id) {
      if (this.selectedWebsite) {
        return this.selectedWebsite.id === id ? "--active" : "";
      }
    },

    async selectFirstWebsite() {
      if (this.competitionWebsites.length > 0) {
        this.loadingScreenshot = true;
        this.selectedWebsite = await this.competitionWebsites[0];

        this.screenshot.laptop.screenshotSrc = this.selectedWebsite.screenshot_desktop_url;
        this.screenshot.mobile.screenshotSrc = this.selectedWebsite.screenshot_mobile_url;

        this.competitionWebsites[0];
        this.loadingScreenshot = false;
      } else {
        this.screenshot.laptop.screenshotSrc = "";
        this.screenshot.mobile.screenshotSrc = "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.competition__card {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
}

.--active {
  background-color: rgba($primary, 0.25);
}

.summary__header {
  color: $grey-darker;
  font-weight: 600;
}

.no-data-info {
  width: 70%;
  color: $gray-light;
  text-align: center;
}

.no-suggested {
  color: $gray-light;
  width: 100%;
}

.laptop-screenshot {
  background: url("~@/static/laptop.png") center center no-repeat;
  height: 487px;
  width: 879px;
  position: absolute;
  margin-top: 40px;
  top: 0;
  left: 0;
}

.laptop-screenshot__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    165.85deg,
    rgba(255, 255, 255, 0.0299125) -15.9%,
    rgba(0, 0, 0, 0.075) 84.42%
  );
  border: 1px solid rgba(52, 55, 58, 0.1);
  margin-top: 29px;
  margin-left: 83px;
  width: 711px;
  height: 396px;
}

.placeholder__text {
  color: rgba($dark, 0.3);
}

.laptop-screenshot__image {
  height: auto;
  width: 100%;
}

.mobile-screenshot {
  background: url("~@/static/iphone.png") center center no-repeat;
  height: 524px;
  width: 322px;
  position: absolute;
  margin-top: 64px;
  top: 0;
  right: 60px;
  z-index: 1;
}

.mobile-screenshot__image {
  height: 100%;
  width: 100%;
  border-radius: 19px;
}

.mobile-screenshot__placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(
    165.85deg,
    rgba(255, 255, 255),
    rgba(0, 0, 0, 0.075)
  );
  border: 1px solid rgba(52, 55, 58, 0.1);
  margin-top: 72px;
  margin-left: 98px;
  width: 176px;
  height: 380px;
  text-align: center;
  border-radius: 19px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.info-hint {
  @include font-size(14px);
}

.item-text {
  @include font-size(16px);
}
</style>
